<script>
// An illustration of what a heatmap looks like over an image - a simplified
// portrait with the regions that drove an AI verdict glowing. Not a real
// scan; the caption says so.
export default {
    name: 'HeatmapFigure',
}
</script>

<template>
    <figure class="ps-heatmap mb-0">
        <div class="ps-heatmap__frame">
            <svg viewBox="0 0 400 480" class="ps-heatmap__art" role="img" aria-labelledby="ps-heatmap-title">
                <title id="ps-heatmap-title">A portrait with the face and hair glowing, marking where AI was detected</title>
                <defs>
                    <linearGradient id="ps-hm-bg" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stop-color="#0b3556" />
                        <stop offset="1" stop-color="#06233b" />
                    </linearGradient>
                    <radialGradient id="ps-hm-hot" cx="0.5" cy="0.5" r="0.5">
                        <stop offset="0" stop-color="#c46eff" stop-opacity="0.95" />
                        <stop offset="0.45" stop-color="#6d34ff" stop-opacity="0.6" />
                        <stop offset="1" stop-color="#1b9aff" stop-opacity="0" />
                    </radialGradient>
                    <radialGradient id="ps-hm-warm" cx="0.5" cy="0.5" r="0.5">
                        <stop offset="0" stop-color="#5141ff" stop-opacity="0.7" />
                        <stop offset="1" stop-color="#1b9aff" stop-opacity="0" />
                    </radialGradient>
                    <pattern id="ps-hm-grid" width="20" height="20" patternUnits="userSpaceOnUse">
                        <path d="M20 0H0V20" fill="none" stroke="#eaf4ff" stroke-opacity="0.06" stroke-width="1" />
                    </pattern>
                </defs>

                <rect width="400" height="480" fill="url(#ps-hm-bg)" />
                <!-- Portrait: shoulders, neck, head, hair -->
                <path d="M40 480c8-86 64-128 160-128s152 42 160 128z" fill="#0f4470" />
                <rect x="172" y="282" width="56" height="84" rx="22" fill="#14507f" />
                <ellipse cx="200" cy="214" rx="78" ry="96" fill="#1a5d92" />
                <path d="M120 206c-4-76 40-120 84-120 52 0 86 40 80 116-14-38-44-58-84-58s-64 22-80 62z" fill="#0c3a60" />

                <!-- Heat -->
                <ellipse cx="200" cy="222" rx="96" ry="104" fill="url(#ps-hm-hot)" />
                <ellipse cx="236" cy="128" rx="80" ry="54" fill="url(#ps-hm-warm)" />
                <ellipse cx="128" cy="396" rx="60" ry="40" fill="url(#ps-hm-warm)" opacity="0.5" />

                <rect width="400" height="480" fill="url(#ps-hm-grid)" />
            </svg>
            <div class="ps-heatmap__legend d-flex align-items-center">
                <span class="small text-muted">Less</span>
                <span class="ps-heatmap__ramp mx-2" aria-hidden="true"></span>
                <span class="small text-muted">More evidence of AI</span>
            </div>
        </div>
        <figcaption class="ps-figcaption mt-3">
            <strong>Figure 3.</strong>
            Illustration of a heatmap over an AI-edited image. Brighter regions contributed more to the classification. The untouched background contributes little.
        </figcaption>
    </figure>
</template>

<style scoped lang="scss">
.ps-heatmap__frame {
    position: relative;
    border: 1px solid var(--ps-rule);
    border-radius: 0.5rem;
    overflow: hidden;
    background: var(--ps-ink);
}

.ps-heatmap__art {
    display: block;
    width: 100%;
    height: auto;
}

.ps-heatmap__legend {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    padding: 0.4rem 0.75rem;
    border-radius: 0.375rem;
    background: rgba(3, 23, 38, 0.85);
}

.ps-heatmap__ramp {
    width: 4.5rem;
    height: 0.4rem;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(27, 154, 255, 0.25), var(--ps-indigo), #c46eff);
}
</style>
